import React from "react";

const PaymentTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="flex flex-wrap gap-4 mb-4">

      {[
        ["all", "All"],
        ["credit", "Credit"],
        ["debit", "Debit"],
        ["linked", "Linked Payments"],
      ].map(([tab, label]) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-4 py-2 rounded ${
            activeTab === tab
              ? "bg-blue-600 text-white"
              : "bg-gray-200"
          }`}
        >
          {label}
        </button>
      ))}

    </div>
  );
};

export default PaymentTabs;